export const addToLocalStorage = (key, value) => {
  localStorage.setItem(key, value);
};

export const getFromLocalStorage = (key) => {
  const decryptedValue = localStorage.getItem(key);
  return decryptedValue;
};

/**
 * localStorage stringifies whatever it is given, so a missing value from the session
 * response is stored as the literal "null" / "undefined" - both truthy strings. Reads
 * that feed URLs or query params must go through here.
 */
export const getStoredId = (key) => {
  const value = localStorage.getItem(key);
  if (!value || value === 'null' || value === 'undefined' || value === 'NaN') {
    return null;
  }
  return value;
};
